import React from 'react'

export default function FinancialStatus() {
  return <div>FinancialStatus</div>
}
